import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input, Space, Table, Tag } from 'antd';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { checkValue, formatDate } from 'utils';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';

function UsersTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  onRowClick,
  onChange,
}) {
  const columns = [
    {
      title: 'ФИО',
      dataIndex: 'full_name',
      key: 'full_name',
      render: checkValue,
      filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по ФИО"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.full_name?.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: 'Почта',
      dataIndex: 'email',
      key: 'email',
      render: checkValue,
    },
    {
      title: 'Роль',
      dataIndex: 'roles',
      key: 'roles',
      render: (roles) => {
        if (roles.length) {
          return (
            <Space direction="vertical">
              {roles?.map((item) => (
                <Tag style={{ margin: 0 }}>{item.name}</Tag>
              ))}
            </Space>
          );
        }

        return '---';
      },
    },
    {
      title: 'Трайб',
      dataIndex: 'tribes',
      key: 'tribes',
      render: (tribes) => {
        if (tribes.length) {
          return (
            <Space direction="vertical">
              {tribes?.map((item) => (
                <Tag style={{ margin: 0 }}>{item.title}</Tag>
              ))}
            </Space>
          );
        }

        return '---';
      },
    },
    {
      title: 'Дата регистрации',
      dataIndex: 'created',
      key: 'created',
      render: (date) => formatDate(date),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      tableLayout="fixed"
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        total: totalRows,
        pageSize,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { UsersTable };
